"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const C2dDefaultShader_1 = require("./C2dDefaultShader");
class C2dBlurShader extends C2dDefaultShader_1.C2dDefaultShader {
    constructor() {
        super(...arguments);
        this._kernelRadius = 1;
    }
    get kernelRadius() {
        return this._kernelRadius;
    }
    set kernelRadius(v) {
        this._kernelRadius = v;
        this.redraw();
    }
    useDefault() {
        return this._kernelRadius === 0;
    }
    _beforeDrawEl(info) {
        info.target.context.filter = "blur(" + this._kernelRadius + "px)";
    }
    _afterDrawEl(info) {
        info.target.context.filter = "none";
    }
}
exports.C2dBlurShader = C2dBlurShader;
//# sourceMappingURL=C2dBlurShader.js.map